import { Dropdown } from 'react-bootstrap'
import { PAYMENT_STATUS } from '../constants'
import { Button, ButtonActiveSpin, ButtonGroup, ButtonGroupContainer, FormControl, Header } from '../styles'
import {
  NUMBER_LOTTERY,
  formatNumberLottery,
  getBackgroundColorByStatus,
  getButtonTextByNumberLottery,
  getButtonTextByStatus,
  getNumberLotteryMaxLength,
} from '../utils'
import { useState } from 'react'

const PreOrderFilter = ({ searchParams, onUpdateSearchParams, fetchPayments, onClickResetFilter }) => {
  const isSearching =
    searchParams.orderNo ||
    searchParams.userNo ||
    searchParams.firstName ||
    searchParams.lastName ||
    searchParams.phoneNo ||
    searchParams.number

  const [numberLottery, setNumberLottery] = useState(NUMBER_LOTTERY.ALL)

  const handleChangeNumberType = (type) => {
    setNumberLottery(type)
    onUpdateSearchParams('number', '')
  }

  const handleUpdateNumberValue = (event) => {
    const { value } = event.target

    if (value === '') {
      onUpdateSearchParams('number', '')
      return
    }

    if (/[^0-9]/i.test(value)) return

    onUpdateSearchParams('number', formatNumberLottery(numberLottery, event.target.value))
  }

  const handleClickReset = () => {
    setNumberLottery(NUMBER_LOTTERY.ALL)
    onClickResetFilter()
  }
  return (
    <Header>
      <ButtonGroupContainer>
        <div>
          {Object.values(PAYMENT_STATUS).map((status) => (
            <Button
              key={status}
              onClick={() => onUpdateSearchParams('status', status)}
              isActive={searchParams.status === status}
              color={getBackgroundColorByStatus(status)}
            >
              {getButtonTextByStatus(status)}
            </Button>
          ))}
        </div>
      </ButtonGroupContainer>
      <div
        style={{
          display: 'flex',
          gap: '16px',
        }}
      >
        <form
          style={{
            display: 'flex',
            flexGrow: 1,
            gap: '16px',
          }}
          onSubmit={(event) => {
            event.preventDefault()
            fetchPayments(searchParams)
          }}
        >
          <FormControl
            placeholder="หมายเลขออเดอร์"
            value={searchParams.orderNo}
            onChange={(event) => onUpdateSearchParams('orderNo', event.target.value)}
          />

          <div style={{ display: 'flex' }}>
            <Dropdown as="span">
              <Dropdown.Toggle
                style={{
                  height: '100%',
                  borderWidth: '1px',
                  borderTopLeftRadius: 50,
                  borderBottomLeftRadius: 50,
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  borderRight: 'none',
                  borderColor: 'lightgrey',
                  background: 'white',
                  padding: '6px 12px',
                  color: 'black',
                  fontSize: '14px',
                  hover: 'pointer',
                }}
                isActive={numberLottery}
              >
                {getButtonTextByNumberLottery(numberLottery)}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ border: '2px', borderColor: 'blue' }}>
                {Object.values(NUMBER_LOTTERY).map((number) => (
                  <Dropdown.Item
                    key={number}
                    onClick={() => handleChangeNumberType(number)}
                    style={{ fontSize: '14px' }}
                    isActive={numberLottery}
                  >
                    {getButtonTextByNumberLottery(number)}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <FormControl
              style={{ width: '130px', borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
              placeholder="เลขหวยที่ถูกจอง"
              value={searchParams.number.replaceAll('.', '')}
              maxLength={getNumberLotteryMaxLength(numberLottery)}
              onChange={handleUpdateNumberValue}
            />
          </div>

          <FormControl
            placeholder="รหัสลูกค้า"
            value={searchParams.userNo}
            onChange={(event) => onUpdateSearchParams('userNo', event.target.value)}
          />
          <FormControl
            placeholder="ชื่อ"
            value={searchParams.firstName}
            onChange={(event) => onUpdateSearchParams('firstName', event.target.value)}
          />
          <FormControl
            placeholder="นามสกุล"
            value={searchParams.lastName}
            onChange={(event) => onUpdateSearchParams('lastName', event.target.value)}
          />
          <FormControl
            placeholder="เบอร์โทรศัพท์"
            value={searchParams.phoneNo}
            maxLength={10}
            onChange={(event) => onUpdateSearchParams('phoneNo', event.target.value)}
          />
          <ButtonGroup>
            <Button
              disabled={!isSearching}
              isActive={isSearching}
              color="rgba(0,0,255,0.3)"
              onClick={() => fetchPayments(searchParams)}
            >
              ค้นหา
            </Button>
            {isSearching && (
              <Button isActive onClick={handleClickReset} color="rgba(0,0,255,0.3)" className="fa fa-close" />
            )}
          </ButtonGroup>
        </form>
        <ButtonActiveSpin isActive onClick={() => fetchPayments(searchParams)} color="rgba(173,216,230,1)">
          <span className="fa fa-undo" />
        </ButtonActiveSpin>
      </div>
    </Header>
  )
}

export default PreOrderFilter
